import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../components/api/api';

// Open the existing cabinet conversation. Never send a message on navigation.
export default function usePortalChat(contextKey) {
  const navigate = useNavigate();
  const version = useRef(0);
  const pending = useRef(false);
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    pending.current = false;
    setOpening(false);
    setError('');
    return () => { version.current += 1; };
  }, [contextKey]);

  const openChat = async ({ clientId, dealId }) => {
    if (pending.current) return;
    const id = Number(dealId ?? clientId);
    if (!Number.isSafeInteger(id) || id < 1) {
      setError('Сначала сохраните клиента.');
      return;
    }
    pending.current = true;
    const request = ++version.current;
    setOpening(true);
    setError('');
    try {
      const { data } = await api.post(`/chats/for-${dealId != null ? 'deal' : 'client'}/${id}`);
      if (request !== version.current) return;
      if (!Number.isSafeInteger(data?.id) || data.id < 1) throw new Error('Invalid chat');
      navigate(`/messenger?chat=${data.id}`);
    } catch (err) {
      if (request !== version.current) return;
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Не удалось открыть чат клиента. Попробуйте ещё раз.');
    } finally {
      if (request === version.current) {
        pending.current = false;
        setOpening(false);
      }
    }
  };

  return { openChat, opening, error };
}
